import request from '@/utils/request'

let FeedbackApi = {
  // 反馈列表（后台）
  feedbackList(data, errorback) {
    return request._post('/shop/feedback.feedback/index', data, errorback)
  },
  // 修改反馈状态
  feedbackSetStatus(data, errorback) {
    return request._post('/shop/feedback.feedback/setStatus', data, errorback)
  },
}

export default FeedbackApi




// WEBPACK FOOTER //
// ./src/api/feedback.js